var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("组件通信")]),_c('Child1',{attrs:{"msg":"some msg from parent"},on:{"some-event":_vm.onSomeEvent}}),_c('Child2',{ref:"child2"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }